/**
 * 돌봄서비스 상담문의 컴포넌트
 * 각 서비스별 연락처와 팩스, 이메일 정보를 표시합니다.
 */

import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { Container } from './careStyles';
import {
  SERVICES,
  FAX_INFO,
  EMAIL_INFO,
  MAIN_PHONE,
} from '../../constant/contactInfo';
import { iconTel } from '../../constant/careData';

/**
 * CareContactInfo 컴포넌트
 * 상담문의 페이지의 연락처 정보를 렌더링합니다.
 */
function CareContactInfo() {
  return (
    <Container>
      <TelBox>
        <TelHeader>
          <TelIcon src={iconTel} alt="전화 아이콘" />
          <TelIntro>친절히 성심성의껏 상담해 드립니다.</TelIntro>
        </TelHeader>

        <TelContent>
          <ServiceList>
            {SERVICES.map((service, index) => (
              <ServiceItem key={index}>
                <ServiceName>{service.label}</ServiceName>
                <ServicePhone>{service.phone}</ServicePhone>
              </ServiceItem>
            ))}
          </ServiceList>

          <ContactInfo>
            <ContactText>법인 대표 번호 : {MAIN_PHONE}</ContactText>
            <ContactText>팩스</ContactText>
            <ContactText>- 돌봄 : {FAX_INFO.돌봄}</ContactText>
            <ContactText>- 사회적기업 : {FAX_INFO.사회적기업}</ContactText>
            <ContactText>이메일</ContactText>
            <ContactText>- 돌봄 : {EMAIL_INFO.돌봄}</ContactText>
            <ContactText>- 사회적기업 : {EMAIL_INFO.사회적기업}</ContactText>
          </ContactInfo>

          <FundLinkWrapper>
            <FundLink to="/support/1">더채움돌봄펀드 후원하기 →</FundLink>
          </FundLinkWrapper>
        </TelContent>
      </TelBox>
    </Container>
  );
}

export default CareContactInfo;

/* Styled Components - CareContactInfo 전용 */

const TelBox = styled.div`
  position: relative;
  width: calc(100% + 38px);
  margin-left: -38px;
  min-height: 400px;
  background-color: #f4f4f4;
  padding: 40px;
  display: flex;
  flex-direction: column;
  gap: 30px;
  box-sizing: border-box;

  @media (max-width: 767px) {
    width: 100vw;
    margin-left: -5%;
    padding: 25px 5%;
    min-height: auto;
    gap: 20px;
  }
`;

const TelHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
`;

const TelIcon = styled.img`
  width: 40px;
  height: 40px;
  object-fit: contain;
`;

const TelIntro = styled.p`
  font-family: 'koPubWorld DotumB';
  font-size: 1.8em;
  color: #333333;
  letter-spacing: -0.5px;
  margin: 0;

  @media (max-width: 767px) {
    font-size: 1.2em;
  }
`;

const TelContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 25px;
`;

const ServiceList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const ServiceItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const ServiceName = styled.p`
  font-size: 16px;
  font-family: 'koPubWorld DotumB';
  color: #555555;
  font-weight: bold;
  margin: 0;
`;

const ServicePhone = styled.p`
  font-size: 2.8em;
  line-height: 1em;
  letter-spacing: -1px;
  font-family: 'Nanum Gothic Bold';
  color: #ea4336;
  margin: 0;

  @media (max-width: 767px) {
    font-size: 1.8em;
  }
`;

const ContactInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding-top: 20px;
  border-top: 1px solid #d0d0d0;
  margin-top: 10px;
`;

const ContactText = styled.p`
  font-size: 15px;
  font-family: 'koPubWorld DotumB';
  color: #555555;
  margin: 0;
`;

const FundLinkWrapper = styled.div`
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #d0d0d0;
`;

const FundLink = styled(Link)`
  display: inline-block;
  background-color: #e5857c;
  color: white;
  padding: 12px 24px;
  border-radius: 4px;
  text-decoration: none;
  font-family: 'Nanum Gothic Bold';
  font-size: 15px;
  transition: background-color 0.3s;

  &:hover {
    background-color: #d16f68;
  }

  &:active {
    background-color: #c05f58;
  }

  @media (max-width: 767px) {
    font-size: 13px;
    padding: 10px 20px;
  }
`;
